import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

// Per-location bar inventory: liquor stock, restock/adjust, movements, pour cost.
const base = (restaurantId, locationId) =>
  `${API_URL}/users/restaurant/${restaurantId}/locations/${locationId}/bar-inventory`;

// ---- Stock ----------------------------------------------------------------

// One row per liquor item offered at the location (on-hand, value, low-stock flag).
export const listStock = async (restaurantId, locationId) => {
  const { data } = await axios.get(`${base(restaurantId, locationId)}/stock/`);
  return data?.results || [];
};

// Add full bottles at a unit cost. payload: { bottles, unit_cost, note }
export const restock = async (restaurantId, locationId, dishId, payload) => {
  const { data } = await axios.post(`${base(restaurantId, locationId)}/stock/${dishId}/restock/`, payload);
  return data?.data;
};

// Set the actual counted on-hand. payload: { full_bottles, open_bottle_ml, note }
export const adjust = async (restaurantId, locationId, dishId, payload) => {
  const { data } = await axios.post(`${base(restaurantId, locationId)}/stock/${dishId}/adjust/`, payload);
  return data?.data;
};

// Update the low-stock (par) threshold and/or bottle size.
export const updateSettings = async (restaurantId, locationId, dishId, payload) => {
  const { data } = await axios.patch(`${base(restaurantId, locationId)}/stock/${dishId}/settings/`, payload);
  return data?.data;
};

// The audit log of every change for one item.
export const getMovements = async (restaurantId, locationId, dishId) => {
  const { data } = await axios.get(`${base(restaurantId, locationId)}/stock/${dishId}/movements/`);
  return data || { item: null, results: [] };
};

// ---- Reporting ------------------------------------------------------------

// Location pour-cost summary for a date range. params: { from, to } (ISO dates)
export const getSummary = async (restaurantId, locationId, params = {}) => {
  const q = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v),
  ).toString();
  const { data } = await axios.get(`${base(restaurantId, locationId)}/summary/${q ? `?${q}` : ''}`);
  return data?.data || null;
};
